import { ApolloClient, InMemoryCache } from "@apollo/client";
import { environments } from "../constants";

const myCompanyClient = new ApolloClient({
  uri: `${environments.REACT_APP_BASE_URL}/my-company`,
  cache: new InMemoryCache(),
});

export { myCompanyClient };
